import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6 relative" }
const _hoisted_2 = { class: "flex justify-between items-center mb-2 w-full" }
const _hoisted_3 = { class: "flex justify-end gap-4" }
const _hoisted_4 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_5 = { class: "overflow-x-auto" }
const _hoisted_6 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_7 = { class: "bg-gray-50" }
const _hoisted_8 = {
  key: 0,
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_9 = {
  key: 2,
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_10 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_11 = { class: "hover:bg-gray-50" }
const _hoisted_12 = {
  key: 0,
  class: "px-6 py-4 text-sm text-gray-900"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_17 = { class: "px-6 py-4 text-sm" }
const _hoisted_18 = { class: "flex flex-wrap gap-1" }
const _hoisted_19 = {
  key: 0,
  class: "inline-block px-2 py-0.5 text-xs font-medium rounded-full opacity-75 bg-gray-400 text-gray-700"
}
const _hoisted_20 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_21 = { class: "px-6 py-4 text-sm" }
const _hoisted_22 = { class: "flex flex-wrap gap-1" }
const _hoisted_23 = {
  key: 0,
  class: "text-gray-400 text-xs"
}
const _hoisted_24 = {
  key: 0,
  class: "text-gray-400 text-xs"
}
const _hoisted_25 = { class: "px-6 py-4 text-sm text-gray-900" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_28 = { class: "px-6 py-4 text-sm text-gray-900" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_31 = { class: "px-6 py-4 text-sm text-gray-900" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_34 = { class: "px-6 py-4 text-sm" }
const _hoisted_35 = { class: "space-y-1" }
const _hoisted_36 = { class: "flex items-center gap-2" }
const _hoisted_37 = { class: "w-16 bg-gray-200 rounded-full h-2" }
const _hoisted_38 = {
  key: 2,
  class: "px-6 py-4 text-sm"
}
const _hoisted_39 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_40 = { class: "flex items-center gap-2" }
const _hoisted_41 = { class: "w-16 bg-gray-200 rounded-full h-2" }
const _hoisted_42 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_43 = { class: "px-6 py-4 whitespace-nowrap text-sm" }
const _hoisted_44 = { class: "flex gap-2" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 0,
  class: "bg-gray-50"
}
const _hoisted_48 = ["colspan"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "flex items-center gap-2" }
const _hoisted_51 = { class: "mt-2 p-4 bg-red-50 border border-red-200 rounded-lg transition-all duration-300 ease-in-out" }
const _hoisted_52 = { class: "text-sm text-red-700 leading-relaxed whitespace-pre-wrap" }

import { ref, computed, watch } from 'vue';
import { getVaccinationConfigurationInstructions, VaccineConfiguration, GroupTag } from '@/types/v2';
import { useVaccination } from '@/composables/tasks/vaccination/useVaccination';
import { useVaccinationConfigurations } from '@/composables/tasks/vaccination/useVaccinationConfigurations';
import { useVaccinationTaskOperations } from '@/composables/tasks/vaccination/useVaccinationOperations';
import { useVaccinationProgress } from '@/composables/tasks/vaccination/useVaccinationProgress';
import { useRouter } from 'vue-router';
import FooterActions from '@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue';
import VaccinationModal from '@/components/v2/Tasks/Vaccination/Modals/VaccinationModal.vue';
import WeightModal from "@/components/v2/Tasks/Vaccination/Modals/WeightModal.vue";
import { useWeight } from "@/composables/tasks/vaccination/useVaccinationWeight";
import WeightIcon from "@/components/v2/UI/Icons/WeightIcon.vue";
import DocumentIcon from "@/components/v2/UI/Icons/DocumentIcon.vue";
import InfoIcon from "@/components/v2/UI/Icons/InfoIcon.vue";
import { getVaccinationProductDisplayItems, isLikelyBathVaccinationConfiguration } from "@/utils/v2/tasks/display";
import RandomWeightProgressCard from "@/components/v2/Tasks/Shared/RandomWeightProgressCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'VaccinationsView',
  setup(__props) {

const router = useRouter();
const selectedConfiguration = ref<VaccineConfiguration | null>(null);

const {
  isIndividualWeightType,
  isNoWeightType,
  isRandomWeightType,
  getWeighedFish,
  getTargetWeightAmount,
  getWeighedFishInConfiguration
} = useWeight();
const { getConfigurationTags, getConfigurationTitle } = useVaccinationConfigurations();
const { getTagStyles } = useVaccinationTaskOperations();
const { getConfigurationVaccinationProgress, getConfigurationWeightProgress } = useVaccinationProgress();

// Modals
const vaccinationModal = ref<boolean>(false);
const weightModal = ref<boolean>(false);
const instructionsModal = ref<boolean>(false);

const toggleInstructionsModal = () => {
  instructionsModal.value = !instructionsModal.value;
};

const openWeightModal = (config?: VaccineConfiguration | null) => {
  weightModal.value = true;
  selectedConfiguration.value = config || null;
}

const openVaccinationModal = (config: VaccineConfiguration) => {
  vaccinationModal.value = true;
  selectedConfiguration.value = config;
}

const goToEquipmentManagement = () => {
  router.push({ name: "VaccinationEquipmentView" });
}

const { configurations } = useVaccination();

// Helper functions to detect bath types
const isSimplifiedBath = (config: VaccineConfiguration): boolean => {
  const bathConfig = config as any;
  return bathConfig.isSimplifiedBath === true && !!bathConfig.tank;
};

const isStandardBath = (config: VaccineConfiguration): boolean => {
  const bathConfig = config as any;
  return bathConfig.isStandardBath === true && !!(bathConfig.sourceTank && bathConfig.destinationTank);
};

const isBathConfiguration = (config: VaccineConfiguration): boolean => {
  return isLikelyBathVaccinationConfiguration(config);
};

// Check if any configuration is a bath configuration
const hasBathConfigurations = computed(() => {
  return configurations.value.some(config => isBathConfiguration(config));
});

const getVaccinesDisplay = (config: VaccineConfiguration) => {
  return getVaccinationProductDisplayItems(config);
};

const getProgress = (configuration: VaccineConfiguration): number => {
  return getConfigurationVaccinationProgress(configuration.key);
};

const getWeightProgress = (configuration: VaccineConfiguration): number => {
  return getConfigurationWeightProgress(configuration.key);
};

const getProgressPercentage = (configuration: VaccineConfiguration): number => {
  const progress = getProgress(configuration);
  const target = configuration.targetAmount;
  return Math.min(Math.round((progress / target) * 100), 100);
};

const getWeightProgressPercentage = (configuration: VaccineConfiguration): number => {
  const progress = getWeightProgress(configuration);
  const target = configuration.targetWeightAmount ?? 0;
  return Math.min(Math.round((progress / target) * 100), 100);
};

const isCompleted = (configuration: VaccineConfiguration): boolean => {
  return getProgress(configuration) >= configuration.targetAmount;
};

// Special instructions state
const showInstructions = ref<Record<string, boolean>>({});

// Initialize instructions as expanded by default
watch(() => configurations.value, (configs) => {
    if (configs) {
        configs.forEach((config) => {
            if (getVaccinationConfigurationInstructions(config) && showInstructions.value[config.key] === undefined) {
                showInstructions.value[config.key] = true;
            }
        });
    }
}, { immediate: true });

const toggleInstructions = (configKey: string) => {
  showInstructions.value[configKey] = !showInstructions.value[configKey];
};

const getConfigInstructions = (config: VaccineConfiguration): string | undefined => {
  return getVaccinationConfigurationInstructions(config);
};

const instructionsColspan = computed(() => {
  const base = hasBathConfigurations.value ? 8 : 10;
  return isIndividualWeightType.value ? base : base - 1;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-2xl font-bold text-gray-800" }, "IVP Administration")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: goToEquipmentManagement,
            class: "px-4 py-2 bg-primary text-white flex items-center gap-2 rounded-lg shadow-sm hover:bg-primary/90 transition-colors duration-200 font-medium text-sm"
          }, [
            _createVNode(InfoIcon),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Equipment", -1))
          ]),
          (!_unref(isIndividualWeightType) && !_unref(isNoWeightType))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openWeightModal())),
                class: "px-4 py-2 bg-primary text-white flex items-center gap-2 rounded-lg shadow-sm hover:bg-primary/90 transition-colors duration-200 font-medium text-sm"
              }, [
                _createVNode(WeightIcon),
                _cache[7] || (_cache[7] = _createTextVNode(" Record Weight "))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({name: 'VaccineWeights'}))),
            class: "px-4 py-2 bg-primary text-white flex items-center gap-2 rounded-lg shadow-sm hover:bg-primary/90 transition-colors duration-200 font-medium text-sm"
          }, [
            _createVNode(DocumentIcon),
            _cache[8] || (_cache[8] = _createTextVNode(" View Weight Records "))
          ])
        ])
      ]),
      (_unref(isRandomWeightType))
        ? (_openBlock(), _createBlock(RandomWeightProgressCard, {
            key: 0,
            class: "sticky top-2 z-10",
            current: _unref(getWeighedFish),
            target: _unref(getTargetWeightAmount)
          }, null, 8, ["current", "target"]))
        : _createCommentVNode("", true),
      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "w-full bg-secondary h-[1px] block" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", _hoisted_7, [
              _createElementVNode("tr", null, [
                (hasBathConfigurations.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Tank"))
                  : _createCommentVNode("", true),
                (!hasBathConfigurations.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[10] || (_cache[10] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Source Tank", -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Source Tags", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Destination Tank", -1))
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[13] || (_cache[13] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Destination Tags", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "IVP", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Method", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Dose (mL)", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Progress", -1)),
                (_unref(isIndividualWeightType))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Weight"))
                  : _createCommentVNode("", true),
                _cache[18] || (_cache[18] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Actions", -1))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configurations), (config) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: config.key
                }, [
                  _createElementVNode("tr", _hoisted_11, [
                    (hasBathConfigurations.value)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                          (isSimplifiedBath(config))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString((config as any).tank?.name || (config as any).tank?.label || 'None'), 1))
                            : (isStandardBath(config))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString((config as any).sourceTank?.name || (config as any).sourceTank?.label || 'None') + " → " + _toDisplayString((config as any).destinationTank?.name || (config as any).destinationTank?.label || 'None'), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(config.destinationTank?.name || config.destinationTank?.label || 'None'), 1))
                        ]))
                      : _createCommentVNode("", true),
                    (!hasBathConfigurations.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("td", _hoisted_16, _toDisplayString(config.sourceTank?.name || config.sourceTank?.label || 'None'), 1),
                          _createElementVNode("td", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((config.sourceGroup?.tags || []).filter((tag) => tag.title !== 'Start Tag'), (tag) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: tag.key,
                                  class: "inline-block px-2 py-0.5 text-xs font-medium rounded-full",
                                  style: _normalizeStyle(_unref(getTagStyles)(tag))
                                }, _toDisplayString(tag.title), 5))
                              }), 128)),
                              (!config.sourceGroup?.tags || config.sourceGroup.tags.filter((tag) => tag.title !== 'Start Tag').length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Untagged "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(config.destinationTank?.name || config.destinationTank?.label || 'None'), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (isSimplifiedBath(config))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((config as any).tank?.animalGroups || []), (group) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: group.key
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((group.tags || []).filter((tag) => tag.title !== 'Start Tag'), (tag) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: tag.key,
                                      class: "inline-block px-2 py-0.5 text-xs font-medium rounded-full",
                                      style: _normalizeStyle(_unref(getTagStyles)(tag))
                                    }, _toDisplayString(tag.title), 5))
                                  }), 128))
                                ], 64))
                              }), 128)),
                              (!((config as any).tank?.animalGroups?.length > 0))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "No tags"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getConfigurationTags)(config), (tag) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: tag.key,
                                  class: "inline-block px-2 py-0.5 text-xs font-medium rounded-full",
                                  style: _normalizeStyle(_unref(getTagStyles)(tag))
                                }, _toDisplayString(tag.title), 5))
                              }), 128)),
                              (_unref(getConfigurationTags)(config).length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, "No tags"))
                                : _createCommentVNode("", true)
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      (getVaccinesDisplay(config).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVaccinesDisplay(config), (vaccine, vIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: vIdx,
                                class: "mb-1 last:mb-0"
                              }, _toDisplayString(vaccine.name), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_27, "None"))
                    ]),
                    _createElementVNode("td", _hoisted_28, [
                      (getVaccinesDisplay(config).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVaccinesDisplay(config), (vaccine, vIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: vIdx,
                                class: "mb-1 last:mb-0"
                              }, _toDisplayString(vaccine.method), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, "None"))
                    ]),
                    _createElementVNode("td", _hoisted_31, [
                      (getVaccinesDisplay(config).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVaccinesDisplay(config), (vaccine, vIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: vIdx,
                                class: "mb-1 last:mb-0"
                              }, _toDisplayString(vaccine.dose), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_33, "N/A"))
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["h-2 rounded-full transition-all duration-500", getProgressPercentage(config) === 100 ? 'bg-green-500' : 'bg-primary']),
                              style: _normalizeStyle({ width: `${getProgressPercentage(config)}%` })
                            }, null, 6)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["font-medium", isCompleted(config) ? 'text-green-600' : 'text-gray-900'])
                          }, _toDisplayString(getProgress(config)) + "/" + _toDisplayString(config.targetAmount), 3)
                        ])
                      ])
                    ]),
                    (_unref(isIndividualWeightType))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                          (config.targetWeightAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["h-2 rounded-full transition-all duration-500", getWeightProgressPercentage(config) === 100 ? 'bg-green-500' : 'bg-primary']),
                                      style: _normalizeStyle({ width: `${getWeightProgressPercentage(config)}%` })
                                    }, null, 6)
                                  ]),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["font-medium", _unref(getWeighedFishInConfiguration)(config) >= (config.targetWeightAmount || 0) ? 'text-green-600' : 'text-gray-900'])
                                  }, _toDisplayString(_unref(getWeighedFishInConfiguration)(config)) + "/" + _toDisplayString(config.targetWeightAmount), 3)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_42, "-"))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        (config.targetWeightAmount)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (openWeightModal(config)),
                              class: "px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                            }, " Record Weight ", 8, _hoisted_45))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openVaccinationModal(config)),
                          class: "px-3 py-1.5 text-xs font-medium text-white bg-primary border border-transparent rounded-md hover:bg-primary/90 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                        }, " Administer IVP ", 8, _hoisted_46)
                      ])
                    ])
                  ]),
                  (getConfigInstructions(config))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                        _createElementVNode("td", {
                          colspan: instructionsColspan.value,
                          class: _normalizeClass(showInstructions.value[config.key] ? 'px-6 py-4' : 'px-6 py-1.5')
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (toggleInstructions(config.key)),
                            class: _normalizeClass(["w-full flex items-center justify-between text-left hover:bg-gray-100 rounded transition-colors duration-200", showInstructions.value[config.key] ? 'p-3' : 'p-1.5'])
                          }, [
                            _createElementVNode("div", _hoisted_50, [
                              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-red-500 flex-shrink-0",
                                fill: "currentColor",
                                viewBox: "0 0 20 20"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                  "clip-rule": "evenodd"
                                })
                              ], -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(showInstructions.value[config.key] ? 'text-sm font-semibold text-red-600' : 'text-xs font-semibold text-red-600')
                              }, " Special Instructions ", 2)
                            ]),
                            (_openBlock(), _createElementBlock("svg", {
                              class: _normalizeClass(["w-4 h-4 text-gray-500 transition-transform duration-200", { 'rotate-180': showInstructions.value[config.key] }]),
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, _cache[20] || (_cache[20] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 9l-7 7-7-7"
                              }, null, -1)
                            ]), 2))
                          ], 10, _hoisted_49),
                          _withDirectives(_createElementVNode("div", _hoisted_51, [
                            _createElementVNode("p", _hoisted_52, _toDisplayString(getConfigInstructions(config)), 1)
                          ], 512), [
                            [_vShow, showInstructions.value[config.key]]
                          ])
                        ], 10, _hoisted_48)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    (selectedConfiguration.value)
      ? (_openBlock(), _createBlock(VaccinationModal, {
          key: 0,
          show: vaccinationModal.value,
          configuration: selectedConfiguration.value as VaccineConfiguration,
          onClose: _cache[2] || (_cache[2] = () => vaccinationModal.value = false)
        }, null, 8, ["show", "configuration"]))
      : _createCommentVNode("", true),
    _createVNode(WeightModal, {
      show: weightModal.value,
      configuration: selectedConfiguration.value as VaccineConfiguration,
      onClose: _cache[3] || (_cache[3] = () => weightModal.value = false)
    }, null, 8, ["show", "configuration"]),
    _createVNode(FooterActions, { class: "border-t border-gray-200" }, {
      start: _withCtx(() => [
        _createElementVNode("button", {
          onClick: toggleInstructionsModal,
          class: "w-full"
        }, " Instructions ")
      ]),
      middle: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'VaccineConfigurations' }))),
          class: "w-full"
        }, " Back ")
      ]),
      end: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'VaccineOverview' }))),
          class: "w-full"
        }, " Overview ")
      ]),
      _: 1
    })
  ], 64))
}
}

})